import { useQuery } from '@tanstack/react-query';
import { proposalProjectApiConnect } from '../lib/api/proposalProjectApi.connect';
/**
 * Fetch page visualization with OCR blocks for a specific document page.
 *
 * Always served by the zou Connect handler: it resolves the document by
 * attachment id, baltigo doc id, source filename, AND MinIO-direct for pipeline
 * docs that have no attachment row (award/modification PDFs whose source refs
 * carry the pipeline id), and it normalizes 0/1-based page numbering so block
 * highlights land on the right page. The legacy express REST route (now dead
 * for the viewer) did none of that, so a citation carrying a pipeline/artifact
 * id 404'd there — the viewer opened but never loaded the document.
 */ export function useDocumentPages(projectId, docId, pageNum) {
    return useQuery({
        queryKey: [
            'documentPage',
            projectId,
            docId,
            pageNum
        ],
        queryFn: ()=>proposalProjectApiConnect.getPageVisualization(projectId, docId, pageNum),
        staleTime: 300000,
        enabled: !!projectId && !!docId && pageNum > 0
    });
}
